import { BadgeCheck } from "lucide-react";
import { Reveal, SectionHeading, Eyebrow } from "./Reveal";
import { ABOUT_CHIPS } from "../config/site";

export default function About() {
  return (
    <section id="about" className="relative scroll-mt-24 py-24 sm:py-28" data-testid="about-section">
      <div
        className="pointer-events-none absolute left-1/2 top-0 h-[380px] w-[700px] -translate-x-1/2 rounded-full bg-indigo-600/[0.07] blur-[120px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        <div>
          <Eyebrow>Who I Am</Eyebrow>
          <Reveal>
            <h2 className="font-display text-3xl font-bold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl">
              About <span className="text-gradient">Govind Developer</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base leading-relaxed text-slate-400">
              Govind Developer is a professional AI website developer who turns
              business ideas into modern, live websites. I specialise in
              creating professional websites using AI and modern web
              technologies — taking every project from concept to a published,
              working website.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-4 text-base leading-relaxed text-slate-400">
              From businesses, coaching institutes, gyms and colleges to mobile
              shops and personal brands — I design, build, publish and deliver
              websites that are fast, responsive and made to grow your
              business.
            </p>
          </Reveal>
          <Reveal delay={0.26}>
            <div className="mt-8 flex flex-wrap gap-2.5" data-testid="about-chips">
              {ABOUT_CHIPS.map((c) => (
                <span
                  key={c}
                  className="glass inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-medium text-slate-300"
                >
                  <BadgeCheck className="h-3.5 w-3.5 text-indigo-300" />
                  {c}
                </span>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {[
            {
              k: "Concept to Live",
              v: "I handle everything — design, build, publishing and delivery — so you get a website that is already online and working.",
            },
            {
              k: "AI + Modern Web",
              v: "AI-powered tools combined with modern web technologies mean faster delivery and a premium finish.",
            },
            {
              k: "Made to Convert",
              v: "Every layout is planned to turn your visitors into enquiries, admissions and sales.",
            },
            {
              k: "Delivered to You",
              v: "Websites are published on Google and handed over complete — ready to represent your business online.",
            },
          ].map((item, i) => (
            <Reveal key={item.k} delay={0.08 * i} className="h-full">
              <div className="glass card-hover h-full rounded-2xl p-6" data-testid={`about-card-${i}`}>
                <span className="font-mono text-xs font-semibold text-indigo-300/80">
                  0{i + 1}
                </span>
                <h3 className="mt-3 font-display text-lg font-bold text-white">
                  {item.k}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">
                  {item.v}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
